__turbopack_context__.v({
  "badge": "_4IcZQG_badge",
});
